import { getUSQStore } from '../store/store';

/** Returns StorageData which has more
 * usage percentage
 */
export const getEffectiveStorageInfo = () => {
    const { emailStorage, microsoftStorage } = getUSQStore();
    return emailStorage.state > microsoftStorage.state ? emailStorage : microsoftStorage;
};
